import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
//import RestResource from '@/rest_resource';
import * as serviceWorker from './serviceWorker';
import { message } from 'antd';

let ok = true;
function getHost() {
    let host = /http:\/\/([0-9.a-z]+(:\d+)?)\//.exec(document.URL)[0];
    host = host.replace("http://", "");
    host = host.substr(0, host.length - 1);
    return host;
}
//const BASE_URL= {development: 'localhost:3000',production: '192.168.16.242'};
const PATH_PREFIX = {
    development: '/',
    production: '/api'
};
function getPrefix() {
    let env = process.env.NODE_ENV;
    return PATH_PREFIX[env]
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
